import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { observer } from 'mobx-react-lite';
import { useStore } from '@hooks/useStore';
import { useMyTranslations } from '@hooks/useMyTranslations';
import Popup from '@components/Core/Popup/Popup';
import { SECOND_POPUP_WIDTH } from '@components/Core/Popup/constants';
import { MarkersPopup } from '@popups/MarkersPopup';
import { ConfirmationPopup } from '@popups/ConfirmationPopup';
import { StatusPopup } from '@popups/StatusPopup';
import { BrandsTransFields } from '@pages/Brands/types';
import { brandsTranslations } from '@pages/Brands/translations';
import { IBrandFormWithFiles } from '@forms/BrandForm/types';
import { BrandFormPopupsProps, BrandFormPopupsTransFields } from './types';
import { brandFormPopupsTranslations } from './translations';

const BrandFormPopups: FC<BrandFormPopupsProps> = ({ sendRequest, adminMessage }) => {
  const {
    popupStore: { popupName },
  } = useStore();

  const { t } = useMyTranslations<
    BrandFormPopupsTransFields | Extract<BrandsTransFields, 'addBrand'>
  >([brandFormPopupsTranslations.name, brandsTranslations.name]);

  const { getValues, setValue } = useFormContext<IBrandFormWithFiles>();

  return (
    <Popup width={SECOND_POPUP_WIDTH} showClose={popupName === 'markers'}>
      {popupName === 'markers' && (
        <MarkersPopup onSelect={(marker) => setValue('pointerUrl', marker.pointerUrl)} />
      )}
      {popupName === 'confirmation' && (
        <ConfirmationPopup
          title={t('addBrand', { ns: brandsTranslations.name })}
          onAccept={() => sendRequest(getValues())}
          text={t('confirmationText')}
        />
      )}
      {popupName === 'status' && adminMessage && (
        <StatusPopup status="Revise" text={adminMessage} />
      )}
    </Popup>
  );
};

export default observer(BrandFormPopups);
